import React from 'react'

import PropTypes from 'prop-types'

import './processo-duplo.css'

const ProcessoDuplo = (props) => {
  return (
    <div className={`processo-duplo-container1 ${props.rootClassName} `}>
      <div className="processo-duplo-container2">
        <div className="processo-duplo-container3">
          <div className="processo-duplo-container4">
            <span className="Title processo-duplo-text1">{props.title1}</span>
            <span className="processo-duplo-text2 Content">{props.text1}</span>
          </div>
          <div className="processo-duplo-container5">
            <span className="processo-duplo-text3">{props.title}</span>
            <span className="processo-duplo-text4 Content">{props.text}</span>
          </div>
        </div>
      </div>
      <img
        alt={props.imageAlt}
        src={props.imageSrc}
        loading="eager"
        className="processo-duplo-image"
      />
    </div>
  )
}

ProcessoDuplo.defaultProps = {
  imageAlt: 'image',
  text: 'Text',
  title1: 'Title',
  rootClassName: '',
  imageSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
  text1: 'Text',
  title: 'Title',
}

ProcessoDuplo.propTypes = {
  imageAlt: PropTypes.string,
  text: PropTypes.string,
  title1: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc: PropTypes.string,
  text1: PropTypes.string,
  title: PropTypes.string,
}

export default ProcessoDuplo
